import { useEffect, useState } from "react";
import { Box, Text, Spinner, VStack, useToast } from "@chakra-ui/react";
import { supabase } from "../utils/supabaseClient";
import useBusinessGuard from "../hooks/useBusinessGuard"; // ✅ added

export default function DispatchHistory({ campaignId }) {
  const { businessUUID, loading: authLoading } = useBusinessGuard(); // ✅ use UUID
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    const fetchHistory = async () => {
      if (authLoading || !businessUUID || !campaignId) return;

      setLoading(true);
      const { data, error } = await supabase
        .from("dispatch_log")
        .select("*")
        .eq("business_id", businessUUID) // ✅ UUID fix
        .eq("campaign_id", campaignId)
        .order("dispatched_at", { ascending: false })
        .limit(10);

      if (!error && data) {
        setHistory(data);

        data
          .filter(entry => entry.group_id === "auto-fill")
          .forEach(entry => {
            toast({
              title: "Auto-Fill Dispatched",
              description: `📦 ${entry.postcode} filled after 28-day inactivity.`,
              status: "info",
              duration: 5000,
              isClosable: true,
            });
          });
      }

      setLoading(false);
    };

    fetchHistory();
  }, [authLoading, businessUUID, campaignId, toast]);

  return (
    <Box mt={6}>
      <Text fontWeight="bold" mb={2}>🕓 Recent Dispatches</Text>
      {loading ? (
        <Spinner />
      ) : history.length === 0 ? (
        <Text>No dispatches yet.</Text>
      ) : (
        <VStack align="start" spacing={2}>
          {history.map((entry) => (
            <Text key={entry.id} fontSize="sm">
              {entry.postcode} → {entry.flyer_count} flyers ({(entry.saturation * 100).toFixed(1)}%) at {new Date(entry.dispatched_at).toLocaleString()}
              {entry.group_id === "auto-fill" && (
                <Text as="span" ml={2} color="blue.500" fontWeight="bold">[Auto-Fill]</Text>
              )}
            </Text>
          ))}
        </VStack>
      )}
    </Box>
  );
}
